import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-placeholder-command-add",
  "use": "icon-placeholder-command-add-usage",
  "viewBox": "0 0 32 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 24\" id=\"icon-placeholder-command-add\"><g id=\"icon-placeholder-command-add_fill\"><path d=\"M25,2l4.82,10L25,22H3.18l4.39-9.12L8,12l-.42-.87L3.18,2H25M.28,0H0L5.77,12,0,24H26.21L32,12,26.21,0H.28Z\" /><polygon points=\"19.48 7.19 16.82 7.19 16.82 10.69 13.29 10.69 13.29 13.46 16.82 13.46 16.82 17 19.48 17 19.48 13.46 23.01 13.46 23.01 10.69 19.48 10.69 19.48 7.19\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol